import React from 'react';

import { AStyled } from './A.style';

export const A = ({ children, ...props }: { children: any }) => {
  return <AStyled {...props}>{children}</AStyled>;
};
